import React from 'react';
var SpreadSheetHeader = function (_a) {
    var data = _a.data, columns = _a.columns;
    return (React.createElement("div", { className: "sheet-head-container" },
        React.createElement("div", { className: "sheet", "aria-label": "Data Grid" },
            React.createElement("div", { className: "sheet-head" },
                React.createElement("div", { className: "sheet-row" }, columns.filter(function (c) { return typeof c !== 'undefined'; }).map(function (column, index) {
                    if (!column.invisible) {
                        var left = 0;
                        if (column.fixed) {
                            left = columns.slice(0, index).reduce(function (sum, v) { return sum + v.width; }, 0);
                        }
                        var headerContent = column.label || column.id;
                        return (React.createElement("div", { key: column.id, "data-column": column.id, "data-min-width": column.width, className: "sheet-cell " + (column.fixed ? 'fixed-column' : ''), style: { minWidth: column.width, maxWidth: column.width, left: left + 'px', textAlign: column.align || 'left' } }, headerContent));
                    }
                    else {
                        return (React.createElement(React.Fragment, null));
                    }
                }))))));
};
export default SpreadSheetHeader;
